import {supabase} from './supabaseClient';
export async function estimatePhotoHeight(body,signal){
 const {data:{session}}=await supabase.auth.getSession();
 if(!session?.access_token)throw Error('Sign in and sync this job before estimating from photos.');
 const response=await fetch('/api/height-estimate',{method:'POST',signal,headers:{'Content-Type':'application/json',Authorization:`Bearer ${session.access_token}`},body:JSON.stringify(body)});
 const data=await response.json().catch(()=>({error:'The photo estimate service is unavailable.'}));
 if(!response.ok)throw Error(data.error||'Could not estimate height.');return data;
}
// Decode locally, downsize and re-encode so camera metadata is not uploaded.
export async function prepareHeightPhoto(file){
 if(!file||!file.type.startsWith('image/')||file.size>20*1024*1024)throw Error('Choose an image under 20 MB.');
 const url=URL.createObjectURL(file);
 try{
  const img=await new Promise((resolve,reject)=>{const image=new Image();image.onload=()=>resolve(image);image.onerror=()=>reject(Error('Could not open this photo. Try a JPEG or a screenshot.'));image.src=url;});
  const ratio=Math.min(1,1400/Math.max(img.width,img.height));
  const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(img.width*ratio));canvas.height=Math.max(1,Math.round(img.height*ratio));
  const ctx=canvas.getContext('2d');if(!ctx)throw Error('Photo conversion is unavailable in this browser.');ctx.drawImage(img,0,0,canvas.width,canvas.height);
  const data=canvas.toDataURL('image/jpeg',0.8);
  if(data.length>1398000)throw Error('This photo is too detailed. Crop it to the building and retry.');return data;
 }finally{URL.revokeObjectURL(url);}
}
